import React, { useEffect, useState } from 'react';
import { Card, CardBody, Row, Col, Button, Alert } from 'reactstrap';
import { urlCalcularPrimaApAbierto, urlPdfApAbierto, urlProcesoApAbierto } from '../../constants/urls';
import { Textbox, Textarea } from "react-inputs-validation";
import { FetchDescargarCotizacionAbierto } from '../../redux/actions/aCotizacion';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorMsgConstants } from '../../constants';
import NumberFormat from 'react-number-format';




const ValoresParametrico = ({
  codigoCotizador,
  datosCarrito,
  verBoton,
  carritoActual,
  productos,
  editaAsistencias,
  setEditaAsistencias,
  totales,
  idCarrito,
  idProducto,
  categoriaObjeto,
  categoria,
  numeroPersonas,
  muerteAccidental,
  setTotales,
  paso,
  valuesCoberturas,
  tieneErrores,
  history,
  coberturas2,
  asistenciasSeleccionadas,
  codProducto,
  setLoading,
  urlPdf,
  calcular,
  setCalcular,
  guardarPersonas,
  errorGlobal,
  onClickResumen,
  duplicada,
  mensajeDuplicado,
  titulo,
  disabled,
  personaDuplicadaMasivo,
  idDuplicadaMasivo,
  observacionNoValida,
  isEnabledBtnEnviar,
  observacion,
  requiereObservacionObligatoria,
}) => {

  const [tieneError, setTieneError] = useState(false)

  const [correo, setCorreo] = useState('')
  const [validate, setValidate] = useState(false)
  const [hasCorreoError, setHasCorreoError] = useState(false)

  const [errorMensaje, setErrorMensaje] = useState('')
  const [visibleAlert, setVisibleAlert] = useState(false)
  const [okEnvio, setOkEnvio] = useState(false)
  const [tieneVacios, setTieneVacios] = useState(false)
  const [tieneVaciosCategoria, setTieneVaciosCategoria] = useState('')
  const [primaNetaTitulo, setPrimaNetaTitulo] = useState('Prima Neta')
  const [primaTotalTitulo, setPrimaTotalTitulo] = useState('Prima Neta')
  const [divisible, setDivisible] = useState(1)
  const [errorObservacion, setErrorObservacion] = useState(false)

  const scrollToObservacion = () => {
    const el = document.getElementById('observacion-container');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const textarea = el.querySelector('textarea');
      if (textarea) {
        textarea.style.border = '2px solid #dc3545';
        textarea.style.boxShadow = '0 0 5px rgba(220, 53, 69, 0.5)';
        textarea.focus();
      }
    }
  }

  const dispatch = useDispatch()

  const descargarCotizacion = (datos) => dispatch(FetchDescargarCotizacionAbierto(datos))
  const datosCotizacion = useSelector((state) => state.generarCotizacionPdfAP)


  useEffect(() => {
    console.log('codigoCotizador', codigoCotizador)
    if(datosCarrito && datosCarrito.carDatosCliente &&  datosCarrito.carDatosCliente.values &&  datosCarrito.carDatosCliente.values.facturacion && paso == 'resumen' && codigoCotizador=='vidaAsistenciaMedicasAsistencias' ){
      if(datosCarrito.carDatosCliente.values.facturacion.value =="6"){
        setPrimaNetaTitulo('Prima Neta Mensual')
        setPrimaTotalTitulo('Prima Total Mensual')
        setDivisible(1)
      }else{
        setPrimaNetaTitulo('Prima Neta Anual')
        setPrimaTotalTitulo('Prima Total Anual')
        setDivisible(1)
      }
    }
 
  }, [datosCarrito])


console.log('OBSERVACION NO VALIDA', observacion);

  const onDismiss = () => {
    setVisibleAlert(!visibleAlert)
  }

  const buscarVacios = () => {

    var aux = false
    productos.forEach(producto => {

      if (!producto.datosPersonas || producto.datosPersonas.length < 1) {
        aux = true
        setTieneVaciosCategoria(producto.datosAp.actividad.label)
      }

    });
    return aux
  }


  const onEnviar = async () => {

    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "enviar",
      correo: correo,
      idCarrito: idCarrito,
      url: urlPdf,
    }
    setLoading(true)
    await descargarCotizacion(datosJson)
    setLoading(false)
    setOkEnvio(true)

    setTimeout(() => {
      setOkEnvio(false)
      setCorreo('')
    }, 5000);
    console.log('datosCotizacion', datosCotizacion)

    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }


  }

  /**
   * Guarda la información de la cotización seleccionada
   * @param {Object} values valores a guardar
   */
  const guardarInformacion = async (values) => {
    var url = `${urlProcesoApAbierto}`;
    setLoading(true)
    const body = {
      "empresa": "AIGMETROPOLITANA",
      "plataforma": "WEB",
      "ambiente": "Desarrollo",
      "pasoCarrito": "guardarDataCobertura",
      "idCarrito": idCarrito,
      "direccion": "TEST",
      "codigoProductoActual": idProducto ? idProducto : "",


      "datosProductos": {
        "actividad": categoriaObjeto,
        "transaccion": true,
        "codCobertura": categoriaObjeto.value,
        "codProducto": codProducto,
        "tituloPlanCobertura": titulo,
        "numeroPersonas": numeroPersonas,
        "valorMuerteAccidental": muerteAccidental,
        "coberturas": totales.coberturas,
        "asistencias": totales.asistencias,
        "primaNetaPorPersona": totales.primaNetaPorPersona,
        "primaNetaTotal": totales.primaNetaTotal,
        "totalAsistencia": totales.totalAsistencia,
        "primaNetaPorPersonaConAsistencia": totales.primaNetaPorPersonaConAsistencia,
        "primaNetaTotalConAsistencias": totales.primaNetaTotalConAsistencias,
        "totalEnAsistenciaPorPersona": totales.totalEnAsistenciaPorPersona

      }
    }
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()
      console.log('verUrl', json)
      if (json.transaccion) {
        history.push({
          pathname: "/cotizacion-accidente-personal-abierto-resumen",
          search: `?id=${json.idCarrito}`, //agregar parametros de la url,
        });
      }
      console.log('verUrl', json)
      setLoading(false)
    } catch (error) {
      console.log('verUrl', error)
      setLoading(false)
    }
  }

  /**
   * Calcular el valor de la prima de acuerdo a parámetros ingresados por el usuario 
   */
  const calcularPrima = async () => {
    var url = `${urlCalcularPrimaApAbierto}`;
    setLoading(true)
    var coberturasAux = []
    for (const key in valuesCoberturas) {
      const element = valuesCoberturas[key];
      const cobertura = coberturas2.find(cobertura => cobertura.codigoCobertura == key)
      const nuevoObjeto = {
        "codigoCobertura": cobertura.codigoCobertura,
        "nombreCobertura": cobertura.cobertura,
        "valorAsegurado": element
      }
      coberturasAux.push(nuevoObjeto)
    }
    var body = {
      "codCobertura": categoria,
      "empresa": "AIGMETROPOLITANA",
      "numeroPersonas": numeroPersonas,
      "valorMuerteAccidental": muerteAccidental,
      "sucursal": carritoActual.sucursal.value,
      "coberturas": coberturasAux,
      "asistencias": asistenciasSeleccionadas
    }
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()
      console.log('verCoberturas', json)
      if (json.transaccion) {
        setTotales(json)
        setTieneError(false)
      } else {
        setTieneError(true)
        setErrorMensaje(json.errorDescripcion)
        setTotales({})
      }
      setEditaAsistencias(false)
      setLoading(false)

    } catch (error) {
      setLoading(false)
      setEditaAsistencias(false)
      setTotales({})
    }
  }

  const onClickEnviar = () => {

    console.log(hasCorreoError)
    if (
      correo &&
      correo !== "" &&
      correo !== null &&
      hasCorreoError === false
    ) {
      console.log('llegue')
      onEnviar(correo);
    }
  }





  return (
    <Card className=''>
      <CardBody>
        <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>

        {(paso == 'resumen' || paso == 'cargaVidas') &&
          <div>
            <Row>
              <Col lg={6} md={6} sm={6} xs={6} >
                <h4>{primaNetaTitulo}</h4>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>

                <NumberFormat
                  value={parseFloat(totales.prima_neta_anual_full_cobertura ? totales.prima_neta_anual_full_cobertura/divisible : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  decimalSeparator={','}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>
                    <h5>{value}</h5>
                  </div>}
                />

              </Col>

              {/*  <Col lg={6} md={6} sm={6} xs={6}>
              <h5>{totales.primaNetaTotal ? "$" + totales.primaNetaTotal : '$0.00'}</h5>
            </Col> */}
            </Row>
            <Row>
              <div id="container-imp">
                <div className="accordion-imp">
                  <input type="checkbox" id="tm" />
                  <label htmlFor="tm" className="accordionitem">
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h4 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                          Impuestos{" "}
                          <i
                            className="fa fa-info-circle"
                            aria-hidden="true"
                          />
                        </h4>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.totalImpuestos)/divisible}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div {...props}>
                            <h5>{value}</h5>
                          </div>}
                        />


                      </Col>
                    </Row>
                  </label>
                  <div className="hiddentext ocultar">


                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>IVA</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.iva_Full_Cobertura)/divisible}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Super bancos 3.5 %</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.super_bancos_Full_Cobertura)/divisible}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Seguro Campesino 0,50%</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.seguro_campesino_Full_Cobertura)/divisible}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Derechos de Emisión</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <NumberFormat
                          value={parseFloat(totales.derecho_emision_Full_Cobertura)/divisible}
                          className="foo"
                          displayType={'text'}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          decimalScale={2}
                          fixedDecimalScale={2}
                          prefix={'$'}
                          renderText={(value, props) => <div
                            {...props}>
                            <h5>{value}</h5>
                          </div>
                          }
                        />

                      </Col>
                    </Row>





                  </div>


                  <hr />

                </div>
              </div>
            </Row>
            <Row>
              <Col lg={6} md={6} sm={6} xs={6}>
                <h5 style={{ fontWeight: "bold" }}>{primaTotalTitulo}</h5>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>
                <NumberFormat
                  value={parseFloat(totales.totalcarrito)/divisible}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  prefix={'$'}
                  renderText={(value, props) => <div
                    {...props}>
                    <h5 style={{ fontWeight: "bold" }}>
                      {value}
                    </h5>
                  </div>
                  }
                />


              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {(urlPdf && paso == 'resumen') && (
                  <a
                    className='btn btn-detail-white'
                    href={urlPdf}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <i
                      className='fa fa-cloud-download'
                      aria-hidden='true'
                    />{" "}
                    DESCARGAR COTIZACIÓN
                  </a>
                )}
              </Col>

            </Row>
            {(urlPdf && paso == 'resumen') && (
              <Row>
                <Col lg={8} md={12} sm={12} xs={12}>
                  <Textbox
                    tabIndex="1"
                    type="input"
                    value={correo}
                    name="correo"
                    id="correo"
                    classNameInput={"form-control"}
                    onChange={(correo, e) => {
                      setCorreo(correo)
                    }}
                    placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                    validate={validate}
                    validationCallback={(res) => {

                      setHasCorreoError(res)
                      setValidate(!res)



                    }} // Optional.[Func].Default: none. Return the validation result.
                    onBlur={(e) => {
                      // this.setState({ blur: true });
                      //console.log("BLUUUR");
                    }}
                    validationOption={{
                      name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      required: true,
                      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      regMsg: "Por favor ingrese un correo válido",
                      msgOnError: "Por favor ingrese un correo válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                    }}
                  />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <Button
                    className="btn btn-detail-white"
                    onClick={() => {
                      onClickEnviar()
                    }

                    }
                  >
                    <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                  </Button>
                </Col>
                {okEnvio && (
                  <Alert
                    color="success"
                    isOpen={okEnvio}
                    toggle={() => onDismiss()}
                  >
                    <center>
                      <p>
                        Se ha enviado correctamente la cotización al correo
                        electrónico ingresado.
                      </p>
                    </center>
                  </Alert>
                )}
              </Row>
            )}
          </div>


        }

        {paso == 'cotizacion' &&
          <div>
            <Row>


              <Col lg={6} md={6} sm={6} xs={6} >

                <h4>Prima Neta Anual por Persona</h4>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>
                <NumberFormat
                  value={parseFloat(totales.primaNetaPorPersonaConAsistencia ? totales.primaNetaPorPersonaConAsistencia : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  decimalSeparator={','}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>

                    <h5>{value}</h5>

                  </div>}
                />
              </Col>




              {/*  <Col lg={6} md={6} sm={6} xs={6}>
              <h5>{totales.primaNetaTotal ? "$" + totales.primaNetaTotal : '$0.00'}</h5>
            </Col> */}
            </Row>

            <Row>
              <Col lg={6} md={6} sm={6} xs={6}>

                <h5 style={{ fontWeight: "bold" }}>Prima Neta Anual por Póliza</h5>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>

                <NumberFormat
                  value={parseFloat(totales.primaNetaTotalConAsistencias ? totales.primaNetaTotalConAsistencias : '0.00')}
                  className="foo"
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={2}
                  fixedDecimalScale={2}
                  prefix={'$'}
                  renderText={(value, props) => <div {...props}>
                    <h5 style={{ fontWeight: "bold" }}>
                      {value}
                    </h5>
                  </div>}
                />


              </Col>
            </Row>
          </div>


        }


        {paso == 'cotizacion' && verBoton &&
          <Button
            className={
              (!totales.primaNetaPorPersona || editaAsistencias)
                ? "btn btn-primary btn-purple fe-pulse"
                : "btn btn-primary"
            }
            onClick={() => {

              var tieneErroresAux = false


              for (const key in tieneErrores) {
                const element = tieneErrores[key];

                if (element == true) {
                  tieneErroresAux = true
                }
              }

              if (!tieneErroresAux) {

                if (totales.primaNetaPorPersona && !editaAsistencias) {
                  guardarInformacion(valuesCoberturas)
                } else {
                  calcularPrima()
                }

              }

            }}
            style={{ display: "block", margin: "auto", width: 200, height: 40 }}
          >
            <i
              className="fa fa-chevron-circle-right"
              aria-hidden="true"
            />{" "}
            {(totales.primaNetaPorPersona && !editaAsistencias) ? "CONTINUAR" : "CALCULAR"}
          </Button>
        }

        {paso == 'resumen' &&
          <div>
            <Button
              className={
                "btn btn-primary"
              }
              onClick={() => {

                if (observacionNoValida || (requiereObservacionObligatoria && (!observacion || observacion.length === 0))) {
                  setErrorObservacion(true)
                  scrollToObservacion()
                  return
                }

                setErrorObservacion(false)
                onClickResumen()

              }}
              disabled={disabled}
              style={{ display: "block", margin: "auto", width: 200, height: 40 }}
            >
              <i
                className="fa fa-chevron-circle-right"
                aria-hidden="true"
              />{" "}
              {"INICIAR EMISIÓN"}
            </Button>
            {errorObservacion &&
              <div>
                <br></br>
                <Alert color="danger">
                  <center><p>La observación es obligatoria. Por favor ingrese una observación válida para continuar.</p></center>
                </Alert>
              </div>
            }
            {duplicada
              ?
              <div>
                <br></br>
                <Alert color="danger">
                  <center><p>{mensajeDuplicado}</p></center>
                </Alert>
              </div>

              :
              null
            }
          </div>


        }

        {paso == 'cargaVidas' &&
          <div>
            <Button
              disabled={isEnabledBtnEnviar}
              className={
                calcular
                  ? "btn btn-primary btn-purple fe-pulse"
                  : "btn btn-primary"
              }
              onClick={() => {

                if (calcular) {
                  guardarPersonas()
                  setCalcular(false)
                } else {

                  if (observacionNoValida || (requiereObservacionObligatoria && (!observacion || observacion.length === 0))) {
                    setErrorObservacion(true)
                    scrollToObservacion()
                  } else {
                    setErrorObservacion(false)
                    onClickResumen()
                  }






                }

              }}
              style={{ display: "block", margin: "auto", width: 200, height: 40 }}
            >
              <i
                className="fa fa-chevron-circle-right"
                aria-hidden="true"
              />{" "}
              {!calcular ? "CONTINUAR" : "CALCULAR"}
            </Button>
            <br></br>

            {(errorGlobal != '') &&
              <Alert
                color="danger"
                isOpen={(errorGlobal != '')}
                toggle={() => onDismiss()}
              >
                <center>
                  <p>
                    {errorGlobal}
                  </p>
                </center>
              </Alert>
            }
          </div>
        }

        {tieneError &&
          <div>
            <br></br>
            <Alert color="warning">


              {
                errorMensaje
              }


            </Alert>
          </div>



        }

        {paso == 'cargaVidas' &&
          <Alert
            color="danger"
            isOpen={personaDuplicadaMasivo && paso == 'cargaVidas'}
          >
            <center>
              <p>
                La persona con Nro. de identificación {idDuplicadaMasivo} se encuentra duplicada, por favor revise los datos

              </p>
            </center>
          </Alert>
        }

        {paso == 'cargaVidas' && tieneVacios &&
          <Alert
            color="danger"
            isOpen={paso == 'cargaVidas' && tieneVacios}
          >
            <center>
              <p>
                {`La categoría "${tieneVaciosCategoria}" no tiene personas asignadas, por favor realice la carga de las vidas`}

              </p>
            </center>
          </Alert>
        }



      </CardBody>
    </Card>
  );
};

export default ValoresParametrico;
